export const GET_PARTICIPANT_ASSESSMENT = "GET_PARTICIPANT_ASSESSMENT";
export const GET_PARTICIPANT_ASSESSMENT_RESULT =
  "GET_PARTICIPANT_ASSESSMENT_RESULT";
export const REDIRECT_TO = "REDIRECT_TO";
export const SET_SELECTED_ANSWER = "SET_SELECTED_ANSWER";
export const RESET_REDIRECTION = "RESET_REDIRECTION";
